import { TextInput } from '../shared/TextInput';
import { FillInputProps } from '../fillInput';

export const EmailInput = (props: FillInputProps<string, object>) => {
  return <TextInput {...props} inputMode="email" />;
};
